type RuntimeEnv = Record<string, string | undefined>

const runtime: RuntimeEnv =
  (typeof window !== 'undefined' &&
    (window as unknown as { _env_?: RuntimeEnv })._env_) ||
  {}

// Runtime config: window._env_ is generated at container start from the host
// .env (Docker/30-generate-env-js.sh). The process.env.* fallbacks are inlined
// by react-scripts at build time and only apply to local `yarn start` dev.
export const ENV = {
  SCREEN_TYPE:
    runtime.REACT_APP_SCREEN_TYPE ?? process.env.REACT_APP_SCREEN_TYPE ?? '',
  CHANNEL_LOGO:
    runtime.REACT_APP_CHANNEL_LOGO ?? process.env.REACT_APP_CHANNEL_LOGO ?? '',
  REFERERS: runtime.REACT_APP_REFERERS ?? process.env.REACT_APP_REFERERS ?? ''
}
